import React, { useEffect, useState, useCallback } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { useNotifications } from "../../../../common/hooks/useNotifications";
import { usePermissionPolling } from "../../../../common/hooks/usePermissionPolling";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { api } from "../../../../utility/api";
const userIcon = require("assets/img/vehicle_on_tracking.png");
const paths = {
    "/dashboard": "Dashboard",
    "/": "Dashboard",
    "/vehicle-types": "Tipo de vehículos",
    "/stations": "Estaciones",
    "/users": "Usuarios",
    "/roles": "Roles y Permisos",
    "/permissions": "Permisos",
    "/emergencies": "Emergencias",
    "/vehicles/create": "Vehículos",
    "/vehicles": "Vehículos",
    "/settings": "Configuración",
    "/tracking": "Trackeo",
    "/binnacle": "Bitácora",
    "/human_resources/job_management": "Recursos Humanos / Gestión De Puestos",
    "/human_resources/control_hours": "Recursos Humanos / Control De Horas",
    "/human_resources/unsubscribe_discharge":
        "Recursos Humanos / Dar De Baja - Alta",
    "/report/emergency_report": "Reporteria / Reporte de Emergencia",
    "/qr_scan": "Escaneo de QR",
    "/prediccion": "Bomberos Predict",
};
import { vehicletracking } from "../../../../utility/vehicletracking";
import SelectorVehicle from "./SelectorVehicle";
import WebSocketInstance from "../../../../websocket";
import Swal from "sweetalert2";
import { actions } from "../../../../redux/modules/vehiclesEmergency/vehiclesEmergency";
import {
    ROLE_ADMIN,
    ROLE_ADMIN_STATION,
    ROLE_STATION_BOSS,
    ROLE_CABIN_ATTENDANT,
} from "../../../../utility/constants";
import NoSleep from 'nosleep.js';
import "./navbar.css";
import "./navbar-improvements.css";

const Navbar = (props) => {
    // Inicializar notificaciones
    // Initialize permission polling (refresh every 30 seconds for near real-time role updates)
    usePermissionPolling(30);


    // const { permission, requestPermission, unreadCount, resetCount } = useNotifications(); // Replaced below

    const renderPath = window.location.href.split("/");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const history = useHistory();
    const { showButtons, navToggle, navMenu, burgerMenu, logOut, user } = props;
    const [pathTitle, setPathTitle] = useState(paths["/" + renderPath[4]]);
    const [openVehicle, setOpenVehicle] = useState(false);
    const [moblie, setMobile] = useState(false);
    const [screen, setScreen] = useState(false)

    // Notification Logic
    const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [loadingNotifications, setLoadingNotifications] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const onNewMessage = useCallback((payload) => {
        // If dropdown is open, refresh the first page of notifications
        if (notificationDropdownOpen) {
            fetchNotifications(1);
        }
    }, [notificationDropdownOpen]);

    const { permission, requestPermission, unreadCount, fetchUnreadCount, isRegistered } = useNotifications(onNewMessage); // Removed resetCount as we now handle read status per item

    useEffect(() => {
        if (permission === 'default') {
            requestPermission();
        }
    }, [permission]);

    const fetchNotifications = async (currentPage = 1) => {
        if (!hasMore && currentPage !== 1) return;
        setLoadingNotifications(true);
        try {
            const response = await api.get(`/notification/list_notifications?page=${currentPage}&page_size=10`);
            if (response && response.results) {
                if (currentPage === 1) {
                    setNotifications(response.results);
                } else {
                    setNotifications(prev => [...prev, ...response.results]);
                }
                setHasMore(response.next !== null);
                setPage(currentPage);
            } else if (Array.isArray(response)) {
                if (currentPage === 1) {
                    setNotifications(response);
                }
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching notifications", error);
        } finally {
            setLoadingNotifications(false);
        }
    };

    const markAllRead = async () => {
        try {
            await api.post('/notification/mark_all_read');
            fetchUnreadCount();
            // Update local list state
            setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
        } catch (error) {
            console.error("Error marking all read", error);
        }
    };

    const handleNotificationClick = async (notif) => {
        if (!notif.is_read) {
            try {
                await api.post(`/notification/${notif.id}/mark_read`);
                fetchUnreadCount();
                // Update local state
                setNotifications(prev => prev.map(n => n.id === notif.id ? { ...n, is_read: true } : n));
            } catch (error) {
                console.error("Error marking read", error);
            }
        }

        // Navigate
        setNotificationDropdownOpen(false);
        if (notif.data && notif.data.emergency_id) {
            window.location.hash = `#/emergency/${notif.data.emergency_id}`;
        }
    };


    // keep screen active
    const noSleep = new NoSleep();

    const sendMessageHandler = (latitud, longitude) => {
        const vehicleObject = {
            from: "Position Current",
            content: vehicletracking.toStringPosition(
                vehicletracking.getVehicleID(),
                latitud,
                longitude
            ),
            vehicleId: vehicletracking.getVehicleID(),
        };
        waitForSocketConnection(() => {
            WebSocketInstance.newUbication(vehicleObject);
        });
        try {
            if (
                WebSocketInstance.state() !== 1 &&
                WebSocketInstance.state() !== 0
            ) {
                WebSocketInstance.connect(vehicletracking.getVehicleID());
            }
        } catch (e) {
            WebSocketInstance.connect(vehicletracking.getVehicleID());
        }
    };



    const isMoblie = () => {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i,
        ];

        return toMatch.some((toMatchItem) => {
            setMobile(navigator.userAgent.match(toMatchItem));
            return navigator.userAgent.match(toMatchItem);
        });
    };

    const waitForSocketConnection = (callback) => {
        setTimeout(function () {
            if (WebSocketInstance.state() === 1) {
                console.log("Enviando Posicion...");
                callback();
                return;
            } else {
                const vehicle = vehicletracking.getVehicleObj();
                props.changeStatusTrackingStop(vehicle.id, vehicle, false);
                Swal.fire({
                    icon: "error",
                    title: "ERROR",
                    text: "No se pudo enviar los datos al servidor, trackeo detenido.",
                });
            }
        }, 1000);
    };

    useEffect(() => {
        return history.listen((location) => {
            if (location && location.pathname) {
                setPathTitle(paths[location.pathname]);
            }
        });
    }, [history]);

    useEffect(() => {
        isMoblie();
        vehicletracking.getVehicleID() &&
            props.status_vehicle(vehicletracking.getVehicleID());
    }, []);

    const geo_position_error = () => {
        const vehicle = vehicletracking.getVehicleObj();
        props.changeStatusTrackingStop(vehicle.id, vehicle, false);
        Swal.fire({
            icon: "error",
            title: "ERROR",
            text: "No se puede obtener la localizacion del dispositivo",
        });
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (vehicletracking.getVehicle()) {
                navigator.geolocation.getCurrentPosition(
                    sendPosition,
                    geo_position_error
                );
            }
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    function sendPosition(position) {
        sendMessageHandler(position.coords.latitude, position.coords.longitude);
    }

    const stopTracking = (vehicle) => {
        Swal.fire({
            title: "¿Desea detener el trackeo?",
            text: "¡No podrá revertir esta acción!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "¡Sí, detener trackeo!",
            cancelButtonText: "No, cancelar",
            reverseButtons: true,
            confirmButtonColor: "#0F45C7",
        }).then((result) => {
            if (result.value) {
                if (vehicle) {
                    props.changeStatusTracking(vehicle.id, vehicle, false);
                }
            }
        });
    };

    const handleChangeSelectorVehicle = () => {
        if (vehicletracking.getVehicle()) {
            stopTracking(vehicletracking.getVehicleObj());
        } else {
            setOpenVehicle(!openVehicle);
        }
    };

    const closeModal = () => setOpenVehicle(false);

    const [userStatus, setUserStatus] = useState(null);


    useEffect(() => {
        // Fetch current status
        const fetchStatus = async () => {
            try {
                const response = await api.get('user/me');
                if (response) {
                    setUserStatus(response);
                }
            } catch (error) {
                console.error("Error fetching status", error);
            }
        };

        fetchStatus();
        // Poll every minute
        const interval = setInterval(fetchStatus, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <React.Fragment>
            <nav className={showButtons ? "navbar-menu" : ""}>
                {/* ── Notification Permission Banner ── */}
                {(() => {
                    const isAndroid = /Android/i.test(navigator.userAgent);
                    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                    const isMobileDevice = isAndroid || isIOS;

                    if (permission === 'granted') return null;

                    const isDenied = permission === 'denied';

                    // Instructions by platform
                    let instructions = '';
                    if (isDenied) {
                        if (isAndroid) {
                            instructions = 'En Android: ve a Configuración → Aplicaciones → Navegador → Notificaciones y actívalas.';
                        } else if (isIOS) {
                            instructions = 'En iPhone: ve a Configuración → Notificaciones → Safari → activa "Permitir notificaciones".';
                        } else {
                            instructions = 'En el navegador: haz clic en el ícono 🔒 junto a la URL → Notificaciones → Permitir.';
                        }
                    }

                    return (
                        <div style={{
                            backgroundColor: isDenied ? '#f8d7da' : '#fff3cd',
                            color: isDenied ? '#721c24' : '#856404',
                            padding: '8px 16px',
                            textAlign: 'center',
                            borderBottom: `1px solid ${isDenied ? '#f5c6cb' : '#ffeeba'}`,
                            fontSize: '0.83rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            gap: '8px',
                            zIndex: 1050,
                        }}>
                            <span className="material-icons" style={{ fontSize: '1.1rem' }}>
                                {isDenied ? 'notifications_off' : 'notifications_none'}
                            </span>
                            <span>
                                {isDenied
                                    ? <span><strong>Notificaciones bloqueadas.</strong> {instructions}</span>
                                    : <span><strong>Activa las notificaciones</strong> para recibir alertas de emergencia en tiempo real.</span>
                                }
                            </span>
                            {!isDenied && (
                                <button
                                    className="btn btn-sm btn-warning"
                                    style={{ fontSize: '0.75rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                                    onClick={() => {
                                        sessionStorage.removeItem('token_check_notified');
                                        requestPermission();
                                    }}
                                >
                                    {isMobileDevice ? '🔔 Activar notificaciones' : '🔔 Permitir notificaciones'}
                                </button>
                            )}
                        </div>
                    );
                })()}

                <div className="navbar-menu-main">
                    {/* HOME */}
                    <div className={!burgerMenu ? "navbar-card-burger-2" : "navbar-card-1"}>
                        <ol
                            className="breadcrumb mt-3 mx-3 mb-0"
                            style={{
                                fontSize: "15px",
                                backgroundColor: "transparent",
                            }}
                        >
                            <li className="breadcrumb-item">
                                <div className="d-inline-block item-icon-wrapper">
                                    <a href="/">
                                        <span
                                            className="material-icons"
                                            style={{ color: "#777777" }}
                                        >
                                            home
                                        </span>
                                    </a>
                                </div>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="title-blue font-weight-bold" style={{ color: "#333", fontSize: "16px" }}>{pathTitle}</span>
                            </li>
                            {userStatus && userStatus.current_status === 'active' && (
                                <li className="breadcrumb-item ml-4">
                                    <span className="badge badge-success px-3 py-2" style={{ fontSize: '0.9rem', borderRadius: '15px' }}>
                                        Entrada: {new Date(userStatus.entry_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </span>
                                </li>
                            )}
                            {userStatus && userStatus.current_status === 'inactive' && (
                                <li className="breadcrumb-item ml-4">
                                    <span className="badge badge-secondary px-3 py-2" style={{ fontSize: '0.9rem', borderRadius: '15px' }}>
                                        Fuera de turno
                                    </span>
                                </li>
                            )}
                        </ol>
                    </div>

                    {/* LIST VEHICLE TRACKING */}
                    <div className="navbar-card-2">
                        <ol
                            className="breadcrumb header__menu--vehicle mt-3 mx-3 mb-0"
                            style={{
                                fontSize: "15px",
                                backgroundColor: "transparent",
                            }}
                        >
                            {(user.role === ROLE_ADMIN ||
                                user.role === ROLE_ADMIN_STATION) &&
                                moblie && (
                                    <React.Fragment>
                                        <div
                                            className="breadcrumb-item"
                                            onClick={(handleChangeSelectorVehicle)}
                                        >
                                            <span className="title-blue">{`Vehículo - ${vehicletracking.getVehicle()
                                                ? vehicletracking.getVehicleplate()
                                                : "Sin definir"
                                                }`}</span>

                                            <img
                                                style={{
                                                    marginLeft: 4,
                                                    width: "24px",
                                                    height: "24px",
                                                }}
                                                src={userIcon}
                                                alt=""
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                        </ol>
                    </div>

                    {/* LIST MENU */}
                    {(!burgerMenu || showButtons) && (
                        <div className={!burgerMenu ? "navbar-card-burger-1" : "navbar-card-3"}>
                            <div className="pos-f-t">
                                <div className="navbar navbar-light justify-content-end">
                                    <button
                                        className="navbar-toggler"
                                        type="button"
                                        onClick={
                                            showButtons ? navToggle : navMenu
                                        }
                                    >
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ACTIONS & NOTIFICATIONS */}
                    <div className="navbar-card-4">
                        {/* Notification Bell */}
                        {/* Notification Bell */}
                        <Dropdown
                            isOpen={notificationDropdownOpen}
                            toggle={() => {
                                // Standard toggle behavior from Reactstrap triggers this
                                if (!notificationDropdownOpen) {
                                    // Opening
                                    if (permission === 'default') {
                                        requestPermission();
                                    }
                                    setPage(1);
                                    setHasMore(true);
                                    fetchNotifications(1);
                                }
                                setNotificationDropdownOpen(!notificationDropdownOpen);
                            }}
                            className="notification-dropdown-container"
                        >
                            <DropdownToggle
                                tag="div"
                                className={`navbar-card-notification ${unreadCount > 0 ? 'notification-bell active' : ''}`}
                                style={{ marginRight: '15px', position: 'relative', cursor: 'pointer' }}
                            >
                                <button
                                    className="btn"
                                    style={{
                                        border: "2px solid #d4d4d5",
                                        padding: "8px",
                                        borderRadius: "50%",
                                        backgroundColor: "white",
                                        width: "45px",
                                        height: "45px",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}
                                >
                                    <span
                                        className="material-icons"
                                        style={{
                                            color: permission === 'granted' ? '#0F45C7' : (permission === 'denied' ? 'red' : '#777777')
                                        }}
                                    >
                                        {permission === 'granted' ? 'notifications_active' : (permission === 'denied' ? 'notifications_off' : 'notifications_none')}
                                    </span>
                                    {unreadCount > 0 && (
                                        <div className="notification-badge">
                                            {unreadCount > 99 ? '99+' : unreadCount}
                                        </div>
                                    )}
                                </button>
                            </DropdownToggle>
                            <DropdownMenu
                                right
                                className="notification-dropdown-menu"
                                style={{ width: '350px', maxHeight: '500px', overflowY: 'auto', padding: 0 }}
                                onScroll={(e) => {
                                    const { scrollTop, scrollHeight, clientHeight } = e.target;
                                    if (scrollHeight - scrollTop - clientHeight < 50 && !loadingNotifications && hasMore) {
                                        fetchNotifications(page + 1);
                                    }
                                }}
                            >
                                <div className="notification-header p-2 border-bottom d-flex justify-content-between align-items-center">
                                    <h6 className="m-0 font-weight-bold">Notificaciones</h6>
                                    {unreadCount > 0 && (
                                        <small
                                            className="text-primary"
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                markAllRead();
                                            }}
                                        >
                                            Marcar todo como leído
                                        </small>
                                    )}
                                </div>
                                {loadingNotifications && page === 1 ? (
                                    <div className="text-center p-3">Cargando...</div>
                                ) : notifications.length === 0 ? (
                                    <div className="text-center p-3 text-muted">No hay notificaciones por leer</div>
                                ) : (
                                    notifications.map((notif) => (
                                        <DropdownItem
                                            key={notif.id}
                                            className={`notification-item border-bottom ${!notif.is_read ? 'bg-light' : ''}`}
                                            style={{ whiteSpace: 'normal', padding: '10px' }}
                                            onClick={() => handleNotificationClick(notif)}
                                        >
                                            <div className="d-flex align-items-start">
                                                <div className="flex-grow-1">
                                                    <div className="d-flex justify-content-between">
                                                        <strong style={{ fontSize: '0.9rem' }}>{notif.title}</strong>
                                                        <small className="text-muted" style={{ fontSize: '0.75rem' }}>{notif.time_ago}</small>
                                                    </div>
                                                    <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>{notif.body}</p>
                                                </div>
                                                {!notif.is_read && (
                                                    <span className="dot-unread ml-2" style={{
                                                        height: '10px',
                                                        width: '10px',
                                                        backgroundColor: '#0F45C7',
                                                        borderRadius: '50%',
                                                        display: 'inline-block',
                                                        marginTop: '5px'
                                                    }}></span>
                                                )}
                                            </div>
                                        </DropdownItem>
                                    ))
                                )}
                                {loadingNotifications && page > 1 && (
                                    <div className="text-center p-2 text-muted">Cargando más...</div>
                                )}
                            </DropdownMenu>
                        </Dropdown>

                        <Dropdown
                            isOpen={dropdownOpen}
                            toggle={() => setDropdownOpen(!dropdownOpen)}
                        >
                            <DropdownToggle
                                color={"transparent"}
                                style={{
                                    border: "2px solid #d4d4d5",
                                    padding: "10px",
                                    paddingBottom: "0px",
                                    borderRadius: "25px",
                                    backgroundColor: "white",
                                }}
                            >
                                <span
                                    className="material-icons actions"
                                    style={{ color: "#777777" }}
                                >
                                    more_vert
                                </span>
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem tag="a" href="#/user-profile">
                                    <div
                                        className="flex row mx-auto align-items-center py-0"
                                    >
                                        <p className="mb-0 mt-2">Ver perfil</p>
                                    </div>
                                </DropdownItem>
                                {(user.role === ROLE_ADMIN ||
                                    user.role === ROLE_ADMIN_STATION ||
                                    user.role === ROLE_STATION_BOSS ||
                                    user.role === ROLE_CABIN_ATTENDANT) && (
                                        <DropdownItem
                                            tag="a"
                                            href="#/emergencies/create"
                                        >
                                            <div
                                                className="flex row mx-auto align-items-center py-0"
                                            >
                                                <p className="mb-0 mt-2">
                                                    Crear emergencia
                                                </p>
                                            </div>
                                        </DropdownItem>
                                    )}
                                {(user.role === ROLE_ADMIN ||
                                    user.role === ROLE_ADMIN_STATION ||
                                    user.role === ROLE_STATION_BOSS) && (
                                        <DropdownItem tag="a" href="#/qr_scan">
                                            <div
                                                className="flex row mx-auto align-items-center py-0"
                                            >
                                                <p className="mb-0 mt-2">QR</p>
                                            </div>
                                        </DropdownItem>
                                    )}

                                {(user.role === ROLE_ADMIN ||
                                    user.role === ROLE_ADMIN_STATION ||
                                    user.role === ROLE_STATION_BOSS) &&
                                    moblie && (
                                        <DropdownItem
                                            onClick={() => {
                                                screen
                                                    ? noSleep.disable()
                                                    : noSleep.enable();
                                                setScreen(!screen);
                                            }}
                                        >
                                            <div className="flex row mx-auto align-items-center py-0">
                                                <p className="mb-0 mt-2">
                                                    {screen
                                                        ? "Desactivar"
                                                        : "Mantener"}{" "}
                                                    pantalla activa
                                                </p>
                                            </div>
                                        </DropdownItem>
                                    )}
                                <DropdownItem divider />
                                <DropdownItem tag="a" href="/" onClick={logOut}>
                                    <div
                                        className="flex row mx-auto align-items-center py-0"
                                    >
                                        <p
                                            className="mb-0 mt-2"
                                            style={{ color: "red" }}
                                        >
                                            Cerrar sesión
                                        </p>
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </nav>
            <SelectorVehicle
                isOpen={openVehicle}
                handleChange={handleChangeSelectorVehicle}
                setVehicle={vehicletracking.setVehicleOnTracking}
                closeModal={closeModal}
            ></SelectorVehicle>
        </React.Fragment>
    );
};

const ms2p = (state) => {
    return {
        ...state.vehiclesEmergency,
        me: state.login.me,
    };
};

const md2p = {
    changeStatusTracking: actions.changeStatusTracking,
    changeStatusTrackingStop: actions.changeStatusTrackingStop,
    status_vehicle: actions.status_vehicle,
};

export default connect(ms2p, md2p)(Navbar);
